const colors = {
    transparent: "transparent",
    current: "currentColor",
    primary: {
        DEFAULT: "#541AB9",
        50: "#EEE8F8",
        100: "#DDD1F1",
        200: "#CCBAE9",
        300: "#BBA3E3",
        400: "#A88CDC",
        500: "#9875D5",
        600: "#875FCD",
        700: "#6531C0",
    },
    layoutColor: "#F3F4F6",
    secondary: {
        DEFAULT: "#6c757d",
        50: "#d8d9d9",
        100: "#5a6268",
        200: "#545b62",
        300: "#4e555b",
    },
    body: "#868ba1",
    heading: "#343a40",
    success: {
        DEFAULT: "#23BF08",
        50: "#d1fdc9",
        100: "#1c9a06",
        200: "#1a8e06",
        300: "#188205",
    },
    warning: {
        DEFAULT: "#F49917",
        50: "#fdefda",
        100: "#da850a",
        200: "#ce7d0a",
        300: "#c27609",
    },
    danger: {
        DEFAULT: "#dc3545",
        50: "#fae3e5",
        100: "#c82333",
        200: "#bd2130",
        300: "##ad1b29",
    },
    info: {
        DEFAULT: "#5B93D3",
        50: "#e8f0f9",
        100: "#3d7fcb",
        200: "#3579c6",
        300: "#3273bc",
    },
    indigo: {
        DEFAULT: "#6610f2",
        50: "#e8dbfd",
        100: "#5b0cdd",
        200: "#560bd0",
        300: "#4709ac",
        400: "#510bc4",
        500: "#4209a0",
    },
    purple: {
        DEFAULT: "#6f42c1",
        50: "#eae3f6",
        100: "#643ab0",
        150: "#6f42c1",
        200: "#5e37a6",
        300: "#4e2d89",
        400: "#59339d",
        500: "#482a80",
    },
    teal: {
        DEFAULT: "#1CAF9A",
        50: "#d2f8f2",
        100: "#189987",
        200: "#178e7d",
        300: "#116d60",
        400: "#158373",
        500: "#106256",
    },
    pink: {
        DEFAULT: "#e83e8c",
        50: "#fce7f0",
        100: "#e5277e",
        200: "#e41c78",
        300: "#c21766",
        400: "#d91a72",
        500: "#b71660",
    },
    ghost: "#ced4da",
    red: {
        50: "#F9EAEA",
        900: "#C1292E",
        600: "#D4696D"
    },
    yellow: {
        50: "#FEF9EB",
        600: "#FBD276",
        900: "#F9BF3B"
    },
    green: {
        50: "#E6F6F1",
        700: "#35B893",
        900: "#03A678"
    },
    gray: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        150: "#f2f4f6",
        200: "#E5E7EB",
        250: "#485e90",
        300: "#D1D5DB",
        350: "#596882",
        400: "#4B5563",
        450: "#cdd4e0",
        500: "#6A7280",
        550: "f3f4f6",
        600: "#adb5bd",
        650: "#5B636A",
        700: "#111827",
        750: "#495057",
        800: "#888e95",
        850: "#e5e9f2",
        900: "#111827",

    },
    blue: {
        DEFAULT: "#0000ff",
        100: "#8ec2f3",
        200: "#ECF3FB",
        500: "#4183D7",
        900: "#4183D7"
    },
    royal: {
        DEFAULT: "#4662D4",
        50: "#3150cf",
        100: "#2e4cc6",
        200: "#2c48bb",
        250: "#2740a7",
        300: "#243c9c",
    },
    flat: {
        1: "#35B893",
        2: "#fc5c65",
        3: "#fd9644",
        4: "#FBD276",
        5: "#2bcbba",
        6: "#20bf6b",
        7: "#eb3b5a",
        8: "#fa8231",
        9: "#f7b731",
        10: "#0fb9b1",
        11: "#45aaf2",
        12: "#4b7bec",
        13: "#a55eea",
        14: "#d1d8e0",
        15: "#778ca3",
        16: "#2d98da",
        17: "#3867d6",
        18: "#8854d0",
        19: "#a5b1c2",
        20: "#4b6584",
    },
    orange: { DEFAULT: "#ea580c", 50: "#fdeadb" },
    nevada: "#656d75",
    geyser: "#dee2e6",
    trout: "#495057",
    pale: "#6c757d",
    alabaster: "#F8F8F8",
    shark: "#212529",
    silver: "#cccccc",
    facebook: "#4267B2",
    twitter: { DEFAULT: "#1DA1F2", 100: "#329CC3" },
    gplus: "#D64937",
    pinterest: "#dc3545",
    github: "#343a40",
    instagram: "#e83e8c",

};

const screens = {
    maxSm: { max: "575px" },
    // => @media (max-width: 575px) { ... }
    maxXl: { max: "1199px" },
    // => @media (max-width: 1199px) { ... }
    maxLg: { max: "991px" },
    // => @media (max-width: 991px) { ... }
    smToMd: { min: "576px", max: "767px" },
    xsToSm: { min: '375px', max: "575px" },
    xxsToXs: { min: '174px', max: "374px" },

    sm: "576px",
    // => @media (min-width: 576px) { ... }

    md: "768px",
    // => @media (min-width: 768px) { ... }

    lg: "992px",
    // => @media (min-width: 992px) { ... }

    xl: "1200px",
    // => @media (min-width: 1200px) { ... }
};

const fontFamily = {
    body: ["Open Sans", "sans-serif"],
    heading: ["Open Sans", "sans-serif"],
    logo: ["Ubuntu", "sans-serif"],

};

const fontSize = {
    xs: "12px",
    sm: "10px",
    base: "12px",
    md: "14px",
    mdlg: "16px",
    lg: "18px",
    h1: "2.1875rem",
    h2: "1.75rem",
    h3: "1.53125rem",
    h4: "1.3125rem",
    h5: "1.09375rem",
    h6: "0.875rem",
};

const lineHeight = {
    body: 1.5,
    heading: 1.2,
};

const boxShadow = {
    xs: "0 0 0 0.2rem",
    sm: "0 2px 3px",
    md: "0 0 10px",
};

const letterSpacing = {
    tightest: "-0.125rem",
    wider: "1px",
};

const spacing = {
    3.8: "0.938rem",
};

const backgroundImage = {
    "gradient-mantle": "linear-gradient(to right, #514A9D 0%, #24C6DC 100%)",
    "gradient-dance": "linear-gradient(to right, #F9D423 0%, #FF4E50 100%)",
    "gradient-transfile": "linear-gradient(to right, #CB3066 0%, #16BFFD 100%)",
    "gradient-white-striped":
        "linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)",
};

const keyframes = {
    rotatePlane: {
        "0%": { transform: "perspective(120px) rotateX(0deg) rotateY(0deg)" },
        "50%": {
            transform: "perspective(120px) rotateX(-180.1deg) rotateY(0deg)",
        },
        "100%": {
            transform: "perspective(120px) rotateX(-180deg) rotateY(-179.9deg)",
        },
    },
    doubleBounce: {
        "0%, 100%": {
            transform: "scale(0)",
        },
        "50%": {
            transform: "scale(1)",
        },
    },
    waveStretchDelay: {
        "0%, 40%, 100%": {
            transform: "scaleY(0.4)",
        },
        "20%": {
            transform: "scaleY(1)",
        },
    },
    wanderingCube: {
        "0%": { transform: "rotate(0deg)" },
        "25%": { transform: "translateX(30px) rotate(-90deg) scale(0.5)" },
        "50%": {
            transform: "translateX(30px) translateY(30px) rotate(-179deg)",
        },
        "50.1%": {
            transform: "translateX(30px) translateY(30px) rotate(-180deg)",
        },
        "75%": {
            transform:
                "translateX(0) translateY(30px) rotate(-270deg) scale(0.5)",
        },
        "100% ": { transform: "rotate(-360deg)" },
    },
    pulseScaleOut: {
        "0%": {
            transform: "scale(0)",
        },
        "100%": {
            transform: "scaleY(1)",
            opacity: 0,
        },
    },
    chasingDotsRotate: {
        "100%": {
            transform: "rotate(360deg)",
        },
    },
    chasingDotsBounce: {
        "0%, 100%": { transform: "scale(0)" },
        "50%": { transform: "scale(1)" },
    },
    threeBounce: {
        "0%, 80%, 100%": { transform: "scale(0)" },
        "40%": { transform: "scale(1)" },
    },
    circleBounceDelay: {
        "0%, 80%, 100%": { transform: "scale(0)" },
        "40%": { transform: "scale(1)" },
    },
    cubeGridScaleDelay: {
        "0%, 70%, 100%": { transform: "scale3D(1, 1, 1)" },
        "35%": { transform: "scale3D(0, 0, 1)" },
    },
    foldCubeAngle: {
        "0%, 10%": {
            transform: "perspective(140px) rotateX(-180deg)",
            opacity: 0,
        },
        "25%, 75%": {
            transform: "perspective(140px) rotateX(0deg)",
            opacity: 1,
        },
        "90%, 100% ": {
            transform: "perspective(140px) rotateX(180deg)",
            opacity: 0,
        },
    },
};

const animation = {
    rotatePlane: "rotatePlane 1.2s infinite ease-in-out",
    doubleBounce: "doubleBounce 2s infinite ease-in-out",
    waveStretchDelay: "waveStretchDelay 1.2s infinite ease-in-out",
    wanderingCube: "wanderingCube 1.8s ease-in-out -1.8s infinite both",
    pulseScaleOut: "pulseScaleOut 1s infinite ease-in-out",
    chasingDotsRotate: "chasingDotsRotate 2s infinite linear",
    chasingDotsBounce: "chasingDotsBounce 2s infinite ease-in-out",
    threeBounce: "threeBounce 1.4s ease-in-out 0s infinite both",
    circleBounceDelay: "circleBounceDelay 1.2s infinite ease-in-out both",
    cubeGridScaleDelay: "cubeGridScaleDelay 1.3s infinite ease-in-out",
    foldCubeAngle: "foldCubeAngle 2.4s infinite linear both",
};

const animationDelay = {
    0: "0s",
    "-1.0": "-1.0s",
    "-1.1": "-1.1s",
    "-1.2": "-1.2s",
    "-0.9": "-0.9s",
    "-0.8": "-0.8s",
    "-0.7": "-0.7s",
    "-0.6": "-0.6s",
    "-0.5": "-0.5s",
    "-0.4": "-0.4s",
    "-0.3": "-0.3s",
    "-0.2": "-0.2s",
    "-0.1": "-0.1s",
    "-0.32": "-0.32s",
    "-0.16": "-0.16s",
};

module.exports = {
    colors,
    screens,
    fontFamily,
    fontSize,
    lineHeight,
    boxShadow,
    letterSpacing,
    spacing,
    backgroundImage,
    keyframes,
    animation,
    animationDelay,
};
